var Curriculog = Curriculog || {};

/**
 * A Backbone.js View that wraps the jQueryUI Dialog widget.
 *
 * @see  http://api.jqueryui.com/dialog/
 * @see  http://backbonejs.org/#View
 *
 * Examples of usage:
 *  ```
 *  // A basic informational dialog with the curriculog defaults and an "OK"
 *  // button that closes the dialog.
 *  d = new Dialog({
 *      title: 'Foo!',
 *      message: 'Bar!',
 *  });
 *
 *  // Or use an existing element as a dialog.
 *  $('body').append('<div id="test" title="Foo">Hello</div>');
 *
 *  // Just set `el` to an element or a jQuery selector.
 *  new Dialog({
 *      el: '#test'
 *  });
 *
 *  // To reuse a complicated configuration, you can extend the Dialog object.
 *  // Note that buttons are defined with the button text as the key and either
 *  // a function definition *or* a string correponding to a method on the
 *  // Dialog object.
 *  SillyDialog = Dialog.extend({
 *      el: '#test',
 *      buttons: {
 *          OK: 'close',
 *          Funky: function () {
 *              this.$el.parent().css({background: 'purple'});
 *          }
 *      },
 *      show: 'slow',
 *      beforeClose: function (event) {
 *          console.log('Bye!');
 *      }
 *  });
 *
 *  new SillyDialog();
 *  ```
 */
Curriculog.Dialog = (function ($, _, Backbone, Dialog) {
    Dialog = Backbone.View.extend({
        // These are defaults for the dialog widget.
        appendTo: 'body',
        autoOpen: true,
        buttons: { OK: 'close' },
        closeOnEscape: true,
        closeText: 'close',
        dialogClass: 'curriculog-dialog',
        draggable: true,
        height: 'auto',
        hide: null,
        maxHeight: false,
        maxWidth: false,
        minHeight: 150,
        minWidth: 150,
        modal: true,
        position: { my: 'center', at: 'center', of: window },
        resizable: false,
        show: null,
        title: null,
        width: 600,

        // If a message property is passed to initialize, then it will be appended
        // to the dialog body.
        message: '',

        events: {
            dialogopen: 'fixBackground',
            dialogclose: 'releaseBackground'
        },

        initialize: function (options) {
            _.extend(this, options);
            this.setElement(this.el);
            this._aliasDialogMethods()
                ._bindButtons()
                .render();
        },

        render: function () {
            if (this.message) {
                this.$el.append(_.result(this, 'message'));
            }
            this.$el.dialog(this._dialogDefaults());
            return this;
        },

        /**
         * @return {Object} Return an object containing only the properties on this
         *   object that should be passed in to the jQueryUI dialog function.
         */
        _dialogDefaults: function () {
            var props = [
                // Dialog Widget Options
                // See http://api.jqueryui.com/dialog/#options
                'appendTo', 'autoOpen', 'buttons', 'closeOnEscape', 'closeText',
                'dialogClass', 'draggable', 'height', 'hide', 'maxHeight',
                'maxWidth', 'minHeight', 'minWidth', 'modal', 'position',
                'resizable', 'show', 'title', 'width',

                // Dialog Widget Events
                // See http://api.jqueryui.com/dialog/#events
                'beforeClose', 'create', 'drag', 'dragStart', 'dragStop', 'focus',
                'resize', 'resizeStart', 'resizeStop',

                // NOTE: We can't use the 'open' and 'close' events as functions
                // since we've already aliased methods with these names from the
                // Dialog widget (see the `_aliasDialogMethods` method).
                // Use a backbone-style events object if you need to bind to these
                // events, but note that the event names are slightly different
                // ('dialogclose', 'dialogbeforeclose', etc.) See the dialog API
                // docs for the correct event names to use.
            ];

            // How awesome is the pick function?
            return _.pick(this, props);
        },

        /**
         * Change the context of the button functions so that `this` points to the
         * Dialog View instead of the element. If you need to access the element
         * from within the button function, use `this.el` or `this.$el`.
         */
        _bindButtons: function () {
            var buttons = _.result(this, 'buttons'),
                boundButtons = {};

            _.each(buttons, function (fn, name, obj) {
                // Debounce running functions for a second
                // to stop fast clicking on buttons in our Dialog boxes
                if (_.isFunction(fn)) {
                    boundButtons[name] = _.bind(_.debounce(fn, 1000, true), this);
                } else if (_.isString(fn)) {
                    boundButtons[name] = _.bind(_.debounce(this[fn], 1000, true), this);
                }
            }, this);
            this.buttons = boundButtons;
            return this;
        },

        /**
         * Alias the methods from the dialog widget.
         * See: http://api.jqueryui.com/dialog/#methods
         *
         * You can call these methods on the dialog like so:
         *     var d = new Dialog();
         *     d.isOpen(); # true
         *     d.close();
         */
        _aliasDialogMethods: function () {
            var methods = [
                'close',
                'destroy',
                'isOpen',
                'moveToTop',
                'open',
                'option',
                'widget'
            ];
            var i, method;
            for (i = 0; i < methods.length; i++) {
                method = methods[i];
                this[method] = _.bind(this.$el.dialog, this.$el, method);
            }
            return this;
        },

        // use these two functions to fix the background while working within
        // the dialog so scroll doesn't reach the buffer and scroll the
        // background too For some reason, dialogopen event isn't working but
        // dialogclose is
        fixBackground: function() {
            $('body').addClass('dialog-opened');
        },

        releaseBackground: function() {
            $('body').removeClass('dialog-opened');
            this.$el.dialog('destroy');
        }
    });
    return Dialog;
})($, _, Backbone, Curriculog.Dialog || {});
